/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import certificateTemplate from './certificate.tpl.html';

export default angular.module('tektelic.certificate', [])
    .directive('tkCertificate', Certificate)
    .name;

/*@ngInject*/
function Certificate() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            certificate: '=',
            isEdit: '=',
            name: '@'
        },
        controller: CertificateController,
        controllerAs: 'vm',
        templateUrl: certificateTemplate
    };
}

/*@ngInject*/
function CertificateController($translate, types, importExport) {

    var vm = this;

    vm.$onInit = function () {
        vm.types = types;
        vm.importFromFile = importFromFile;
        vm.clearCertificate = clearCertificate;
        vm.uploadFromFile = false;
    };

    function importFromFile ($event) {
        var importMessage = $translate.instant('certificate.import-certificate', {name: vm.name});
        var resultFileMessage = $translate.instant('certificate.certificate-result-file', {name: vm.name});
        const allowedFileTypes = [types.fileType.PEM, types.fileType.KEY, types.fileType.CRT, types.fileType.CER, types.fileType.TXT]
        importExport.uploadFile($event, allowedFileTypes, importMessage, resultFileMessage).then(
            (content) => {
                vm.certificate = content;
                vm.uploadFromFile = true;
            },
            function fileSelectCanceled() {
            });
    }

    function clearCertificate () {
        vm.certificate = "";
        vm.uploadFromFile = false;
    }

}


// WEBPACK FOOTER //
// ./src/app/components/certificate.directive.js